// Others
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { urlApiSchedule } from '~/utils/constants/apis';
import { IChangeEventSchedule, IQueryParamSchedule, IScheduleList } from '~/utils/interface/schedule';
import { IExportFile } from '~/utils/interface/common';

const scheduleApi = {
  getListSchedule: (params: IQueryParamSchedule) => {
    const url = urlApiSchedule.getListSchedule;
    return axiosClient.get<IBaseResponse<IScheduleList[]>>(url, { params });
  },

  exportSchedule: (params: IQueryParamSchedule) => {
    const url = urlApiSchedule.exportSchedule;
    return axiosClient.get<IBaseResponse<IExportFile>>(url, { params });
  },

  changeEventSchedule: (body: IChangeEventSchedule) => {
    const url = urlApiSchedule.changEventSchedule;
    return axiosClient.put<IBaseResponse>(url, body);
  },

  revertScheduleToJob: (scheduleId: string) => {
    const url = urlApiSchedule.revertScheduleToJob(scheduleId);
    return axiosClient.post<IBaseResponse>(url);
  },
};

export default scheduleApi;
